<template>
  <!--
            作者 luoyiming
            时间：2019-10-26
            描述：设置-物流公司
        -->
  <div class="user">
    <div class="common-form">租赁协议列表</div>
    <!--添加等级-->
    <div class="common-level-rail">
      <el-select v-model="agreement_type" placeholder="请选择">
        <el-option
          v-for="item in selectData"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-button
        size="small"
        type="primary"
        @click="addClick"
        v-auth="'/contract/contract/add'"
        >添加租赁</el-button
      >
      <el-button
        size="small"
        type="primary"
        @click="addBank"
        v-auth="'/contract/contract/add'"
        >添加银行</el-button
      >
    </div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table
          size="small"
          :data="tableData"
          border
          style="width: 100%"
          v-loading="loading"
        >
          <el-table-column prop="id" label="ID"></el-table-column>
          <el-table-column prop="title" label="协议标题"></el-table-column>
          <el-table-column prop="sort" label="协议排序"></el-table-column>
          <el-table-column
            prop="switch"
            label="开关(1开启1,关闭0)"
          ></el-table-column>
          <el-table-column
            prop="create_time"
            label="创建时间"
          ></el-table-column>
          <el-table-column
            prop="update_time"
            label="更新时间"
          ></el-table-column>
          <el-table-column fixed="right" label="操作" width="90">
            <template slot-scope="scope">
              <el-button
                @click="editClick(scope.row)"
                type="text"
                size="small"
                v-auth="'/problem/problem/edit'"
                >编辑</el-button
              >
              <el-button
                @click="deleteClick(scope.row)"
                type="text"
                size="small"
                v-auth="'/problem/problem/delete'"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
  
  <script>
import SettingApi from "@/api/setting.js";
export default {
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      formInline: {
        user: "",
        region: "",
      },
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {},
      // 协议类型：1：租赁，2：银行
      agreement_type: 1,
      selectData:[
        {
          value:1,
          label:'租赁协议'
        },
        {
          value:2,
          label:'银行协议'
        }
      ]
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  watch:{
    agreement_type(n,o){
      this.getData()
    }

  },
  methods: {
    // 改变开关
    swchange() {
      console.log("关");
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },

    /*获取列表*/
    getData() {
      let self = this;
      let Params = {};
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      Params.agreement_type = self.agreement_type;
      SettingApi.contractList(Params, true)
        .then((data) => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch((error) => {});
    },
    /*打开添加*/
    addClick() {
      this.$router.push('/contract/contract/add?url=' + 1);
    },
    addBank() {
      this.$router.push('/contract/contract/add?url=' + 2);
    },

    /*打开编辑*/
    editClick(item) {
      let self = this;
      self.$router.push({
        path: "/contract/contract/edit",
        query: {
          id: item.id,
          url:self.agreement_type
        },
      });
    },

    /*删除用户*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          self.loading = true;
          SettingApi.contracteDelete(
            {
              id: row.id,
              agreement_type:self.agreement_type
            },
            true
          )
            .then((data) => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: "success",
              });
              self.getData();
            })
            .catch((error) => {
              self.loading = false;
            });
        })
        .catch(() => {});
    },
  },
};
</script>
  
  <style></style>
  


// WEBPACK FOOTER //
// src/views/contract/contract/index.vue